// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"webpack": 0,
	"css-app_globals_css": 0,
	"css-node_modules_pnpm_swiper_11_2_10_node_modules_swiper_swiper_css": 0,
	"css-node_modules_pnpm_swiper_11_2_10_node_modules_swiper_modules_pagination_css-components-mo-1d67c5": 0,
	"css-icons_LoadingImg_css-app_lang_desktop_app_create_Create_module_css-app_lang_desktop_app_p-5ef452": 0,
	"css-components_chat-dom_styles_chat_css": 0,
	"css-app_lang_desktop_app_chat_charId__components_CharInfo_css": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-5adfc3": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-e09e2f": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-9158be": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-63c242": 0,
	"css-app_lang_desktop__components_Character_module_css": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-c9c9a7": 0,
	"css-app_lang_mobile_app_chat_days-together_diary-card_module_css-components-mobile_relationsh-8cb66c": 0,
	"css-app_lang_mobile_app_create_edit-voice_creat_css": 0,
	"css-app_lang_desktop_app_create_creat_css": 0,
	"css-app_lang_desktop_app_profile_userId__components_userEdit_css": 0,
	"css-app_lang_desktop_app_chat_charId__components_ChatList_module_css": 0,
	"css-node_modules_pnpm_next_14_2_23__babel_core_7_29_7_react-dom_18_3_1_react_18_3_1__react_18-c367a1": 0
};

__webpack_require__.f.j = function(chunkId, promises) {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(css\-(app_(lang_(desktop_(app_(c(hat_charId__components_Cha(rInfo|tList_module)_css|reate_creat_css)|profile_userId__components_userEdit_css)|_components_Character_module_css)|mobile_app_c(hat_days\-together_diary\-card_module_css\-components\-mobile_relationsh\-8cb66c|reate_edit\-voice_creat_css))|globals_css)|components(\-mobile_HomeFilter_style_module|_chat\-dom_styles_chat)_css|node_modules_pnpm_(next_14_2_23__babel_core_7_29_7_react\-dom_18_3_1_react_18_3_1__react_18\-(0ce01c|26e88c|497c06|5adfc3|63c242|88f67e|9158be|c367a1|c9c9a7|e09e2f)|swiper_11_2_10_node_modules_swiper_(modules_pagination_css\-components\-mo\-1d67c5|swiper_css))|icons_LoadingImg_css\-app_lang_desktop_app_create_Create_module_css\-app_lang_desktop_app_p\-5ef452)|webpack)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = function(event) {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));